import { useMutation, useQueryClient } from 'react-query';
import { apiService } from '~services/ApiService';

export const useMarkAllAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error>(
    async () => {
      await apiService.put('notifications/mark-all-read');
    },
    {
      onSuccess: () => {
        // Invalidate and refetch notifications to update the list
        queryClient.invalidateQueries('notifications');
        // Invalidate unread count for real-time badge update
        queryClient.invalidateQueries('unreadNotificationsCount');
      },
    }
  );
};